import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import searchOrganizations from 'redux/actions/Common/searchOrganizations';

const ORG_PAGE_SIZE = 20;

// Debounced server-side org search for the organization picker.
const useOrgSearch = ({ debounceMs = 400 } = {}) => {
  const dispatch = useDispatch();
  const [keyword, setKeyword] = useState('');
  const [organizations, setOrganizations] = useState([]);
  const [fetching, setFetching] = useState(false);
  // Drops responses from searches that were superseded while in flight.
  const requestSeq = useRef(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      const seq = ++requestSeq.current;
      setFetching(true);
      dispatch(
        searchOrganizations(
          keyword.trim(),
          ORG_PAGE_SIZE,
          (data) => {
            if (seq !== requestSeq.current) return;
            setOrganizations(data);
            setFetching(false);
          },
          () => {
            if (seq !== requestSeq.current) return;
            setFetching(false);
          },
        ),
      );
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [keyword]);

  return { keyword, setKeyword, organizations, fetching };
};

export default useOrgSearch;
